<template>
  <section
    id="cover"
    class="te-bg-python-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
    style="height: 500px"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faPython"
        class="fa-fw mr-3 mt-2 hidden size-9 md:inline-block"
      />
      Pythonコース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      Pythonを学んで機械学習の基礎を習得
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        Pythonを学習・勉強して機械学習の基礎を習得で
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >きるようになる講座。スクールでは、Pythonで機械学習プログラムを開発することがゴールです。通過率10%を突破した現役エンジニアから学べるオンラインのプログラミングスクール。1人では続かない方のためのパーソナルメンターがつくプログラミングブートキャンプ。専属のパーソナルメンターがマンツーマンでサポート。転職サポートもあり。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>

    <!-- 経済産業省認定バッジ -->
    <TeCommonBadgeReskilling />
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import TeCommonBadgeReskilling from '~/components/Te/TeCommon/Badge/Reskilling/TeCommonBadgeReskilling.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPython } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faPython,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    TeCommonBadgeReskilling,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-python-image {
  background-image: linear-gradient(
    to top,
    rgba(35, 70, 100, .75),
    rgba(62, 123, 175, .75)
  ),
    url('~/assets/images/Te/TeCourse/Python/Cover/python.jpg');
}
</style>
